import { getDatadogInstance } from '@cw-elements/analytics-provider';
import type { MonitoringDomain, MonitoringErrorTypes } from '@protector/api-client';

type RecordValuesType = string | boolean | number;
export interface MonitoringContext {
  [key: string]: Record<string, RecordValuesType> | string | boolean | number | undefined | string[];
  errorType?: MonitoringErrorTypes;
  crashScreen?: boolean;
  domain: MonitoringDomain;
}

type AnyFn<T> = () => T | Promise<T>;

type ErrorHandler = (error: Error) => void;

const handleUnknownError = (error: unknown) => {
  return error instanceof Error ? error : new Error('UnknownError');
};

export const tryCatchWithMonitoring = async <T>(
  fn: AnyFn<T>,
  context: MonitoringContext,
  onError?: ErrorHandler
): Promise<T | undefined> => {
  try {
    const result = fn();
    return result instanceof Promise ? await result : result;
  } catch (error) {
    const err = handleUnknownError(error);
    getDatadogInstance()?.addError(err, context);
    onError?.(err);

    return undefined;
  }
};

export const captureError = (error: unknown, context: MonitoringContext) => {
  const err = handleUnknownError(error);
  getDatadogInstance()?.addError(err, context);
};

export const setGlobalContext = (key: string, value: unknown) => {
  getDatadogInstance()?.setGlobalContextProperty(key, value);
};
